<template>
  <div
    v-if="useButton"
    id="return-to-top-container"
    :class="containerClass"
  >
    <v-btn
      id="return-to-top-button"
      fab
      small
      color="primary"
      @click="returnToTop"
    >
      <v-icon>
        mdi-chevron-up
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReturnToTopButton',

  data: () => ({
    show: false
  }),

  computed: {
    ...mapGetters('dialog', ['dialogCount']),

    useButton () {
      return this.$vuetify.breakpoint.smAndDown
    },

    containerClass () {
      return this.dialogCount > 0 ? 'invisible' : (this.show ? '' : 'invisible')
    }
  },

  watch: {
    show (newValue) {
      const container = document.getElementById('return-to-top-container')
      if (container) {
        container.setAttribute('class', newValue ? '' : 'invisible')
      }
    },

    useButton (newValue) {
      if (!newValue) {
        window.removeEventListener('scroll', this.handleScroll)
      } else {
        window.addEventListener('scroll', this.handleScroll)
        this.handleScroll()
      }
    }
  },

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll () {
      this.show = window.scrollY > this.$vuetify.breakpoint.height
    },

    returnToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
#return-to-top-container {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 48px;
  height: 48px;
}
#return-to-top-container:not(.invisible) {
  opacity: 1;
  z-index: 4;
  transition: opacity 0.3s ease-in-out, z-index 0s, transform 0.3s ease-in-out;
}

#return-to-top-container.invisible {
  opacity: 0;
  z-index: -1;
  transform: translateY(10px);
  transition: z-index .5s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
</style>
